import * as React from 'react'

function SvgDoneOutlineRounded(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.43 13.445l9.93-9.93c.78-.78 2.04-.78 2.83 0l1.4 1.4c.78.78.78 2.05 0 2.83L9.84 20.485c-.78.78-2.05.78-2.83 0l-5.6-5.6c-.78-.78-.78-2.05 0-2.83l1.4-1.4c.78-.78 2.05-.78 2.83 0l2.79 2.79zm12.04-6.41a.984.984 0 000-1.4.984.984 0 00-1.4 0L8.43 16.275l-3.5-3.5a.984.984 0 00-1.4 0 .984.984 0 000 1.4l4.2 4.2c.39.39 1.01.39 1.4 0l11.34-11.34z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgDoneOutlineRounded
